export const USER_REGISTRATION_REQUEST =
  "registration/USER_REGISTRATION_REQUEST";
export type T_USER_REGISTRATION_REQUEST = typeof USER_REGISTRATION_REQUEST;
